import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  DialogActions,
  Button,
} from "@mui/material";

const FileNameDialog = ({ open, onClose, onSave }) => {
  const [fileName, setFileName] = useState("");

  const handleSave = () => {
    if (!fileName.trim()) return;
    onSave(fileName);
    setFileName("");
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Enter File Name</DialogTitle>

      <DialogContent>
        <TextField
          fullWidth
          label="File Name"
          value={fileName}
          onChange={(e) => setFileName(e.target.value)}
        />
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" onClick={handleSave}>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FileNameDialog;
